// src/components/ui/ListState.tsx
import { brand, fonts } from '@/lib/tokens';
import { SkeletonPanel } from './SkeletonCard';
import { EmptyState } from './EmptyState';

export function ListLoading() {
  return <SkeletonPanel />;
}

export function ListError({ label, detail }: { label: string; detail: string }) {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '56px 24px' }}>
      <span className="material-symbols-outlined" aria-hidden style={{ fontSize: 24, color: brand.error }}>
        error
      </span>
      <span style={{ fontFamily: fonts.mono, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', color: brand.monoDim }}>
        {label}
      </span>
      <span style={{ fontFamily: fonts.mono, fontSize: 11, color: brand.errorText }}>
        {detail}
      </span>
    </div>
  );
}

export function ListEmpty({ label, description, icon = 'inbox' }: { label: string; description?: string; icon?: string }) {
  return <EmptyState icon={icon} title={label} description={description} />;
}
